import React, { PureComponent } from 'react';

import get from 'lodash/get';
import PropTypes from 'prop-types';

import { Utils } from '@qality/common-utils';

import EventEmitter from './EventEmitter';

/*
  32 - space
  37-40 - arrows
*/
const BLOCKED_KEY_CODES = [32, 37, 38, 39, 40];

class ShortcutBoundary extends PureComponent {
  static propTypes = {
    children: PropTypes.any.isRequired,
  };

  constructor(props) {
    super(props);
    this.wrapperNode = React.createRef();
  }

  preventKeyboardShortcut = (e) => {
    if (this.shouldStopPropagation(e)) {
      e.stopPropagation();
    }
  };

  // eslint-disable-next-line complexity
  shouldStopPropagation = (e) => {
    const className = get(e, 'srcElement.className');

    if (!Utils.isNilOrEmpty(className) && className.includes('DraftEditor')) {
      if (e.keyCode === 32) {
        EventEmitter.dispatch('space_pressed', '');
      }
      if (e.key === 'k') {
        EventEmitter.dispatch('k_pressed', '');
      }
      if (e.key === 'j') {
        EventEmitter.dispatch('j_pressed', '');
      }
    }

    return !Utils.isNilOrEmpty(className)
      ? !(
          className.includes('DraftEditor') &&
          !BLOCKED_KEY_CODES.includes(e.keyCode)
        )
      : true;
  };

  componentDidMount() {
    const { current } = this.wrapperNode;
    if (current && typeof window.AJS !== 'undefined') {
      window.AJS.$(current).on('aui:keypress', this.preventKeyboardShortcut);
      window.AJS.$(current).on('keydown', this.preventKeyboardShortcut);
      window.AJS.$(current).on('keypress', this.preventKeyboardShortcut);
    }
  }

  componentWillUnmount() {
    const { current } = this.wrapperNode;
    if (current && typeof window.AJS !== 'undefined') {
      window.AJS.$(current).off('aui:keypress', this.preventKeyboardShortcut);
      window.AJS.$(current).off('keydown', this.preventKeyboardShortcut);
      window.AJS.$(current).off('keypress', this.preventKeyboardShortcut);
    }
  }

  render() {
    return <div ref={this.wrapperNode}>{this.props.children}</div>;
  }
}

export default ShortcutBoundary;
